import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { AuthProvider } from '@/features/auth/AuthProvider'
import { ApiError } from '@/lib/api'
import { router } from '@/router'
import '@/styles/global.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Server-Wahrheiten sind kurz haltbar: Salden und Fälligkeiten ändern
      // sich durch einen Job, nicht nur durch eigenes Zutun.
      staleTime: 30_000,
      // Ein 403 wird durch Wiederholen nicht zu einem 200 — nur ein fehlender
      // Grant bleibt ein fehlender Grant. Wiederholt wird nur, was wirklich
      // vorübergehend sein kann.
      retry: (failureCount, error) =>
        error instanceof ApiError && error.status < 500 ? false : failureCount < 2,
    },
  },
})

const container = document.getElementById('root')
if (container === null) throw new Error('Kein #root im Dokument — index.html ist beschädigt.')

// Der `AuthProvider` liegt **zwischen** Query und Router: Ohne Sitzung gibt es
// keinen Router und damit keine Abfrage, die mit einem 401 zurückkommt. Der
// Anmeldebildschirm ist das Tor davor, keine Route dahinter (ADR 0007).
createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
